import { useSyncWorkspaceIdToPosthog } from '@/app-shell/app-root/useSyncWorkspaceIdToPosthog';
import { logout } from '@/lib/authActions';
import { FullPageLoader } from '@heidi/snowflake-ui/full-page-loader';
import { type WorkspaceHydrationGatePorts } from '@heidi/workspace';

/**
 * The app half of `@heidi/workspace`'s `WorkspaceHydrationGate`: the app's
 * full-page loader, the workspace-to-PostHog flag sync and the selector's
 * sign-out. This stays one module-scoped object rather than a hook; the auth
 * mounts take it as a prop and add no hook call.
 */
export const workspaceHydrationGatePorts: WorkspaceHydrationGatePorts = {
  pendingFallback: <FullPageLoader />,
  useSyncHydrationStatus: useSyncWorkspaceIdToPosthog,
  signOut: async () => {
    await logout();
  },
};
